<template>
  <div class="wrap">
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
        <slot name="buttons"></slot>
      </div>
    </div>
    <base-table
      :base-url="urlWithFilters"
      ref="baseTable"
      @load-success="onLoadSuccess"
      @refresh="onRefresh"
      :current-page="currentPage"
      v-loading="isRefreshing"
      element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
          :data="items"
          stripe
          class="w-100"
        >
          <el-table-column
            prop="id"
            label="Id"
            min-width="80"
          ></el-table-column>
          <el-table-column
            prop="phone_number"
            label="Client phone number"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="outgoing_number"
            label="Representative phone number"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="created_at"
            label="Received at"
            min-width="120"
            :formatter="formatDate"
          ></el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      class="text-right"
    ></el-pagination>
  </div>
</template>

<script>
import TableWithPagination from '../../../components/table-with-pagination';
import {addQueryParams} from "../../../libs/url";

export default {
  extends: TableWithPagination,

  components: {
    // ...
  },

  props: {
    params: Object,
  },

  data() {
    return {
      search: null,
      filters: this.params,
    };
  },

  computed: {
    /**
     * @return {string}
     */
    urlWithFilters() {
      return addQueryParams(this.url, this.filters);
    },
  },

  watch: {
    search: function (value) {
      this.filters = value
        ? _.assign({}, this.filters, {search: value})
        : this.filters = _.omit(this.filters, ['search']);
    },
  },

  methods: {
    /**
     * @param {object} row
     * @param {object} col
     * @param {string} datetime
     * @return {string}
     */
    formatDate(row, col, {datetime}) {
      return moment(datetime).format(config('format.moment.short.datetime'));
    },

    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.baseTable.refresh();
    },
  },
};
</script>

<style scoped>

</style>
